export enum FootballPerformanceCategory {
	Scoring = 'scoring',
	GameOutcome = 'game_outcome',
	QuarterbackPlay = 'quarterback_play',
	RushingReceiving = 'rushing_receiving',
}

export const FOOTBALL_PERFORMANCE_CATEGORY_LABELS: Record<FootballPerformanceCategory, string> = {
	[FootballPerformanceCategory.Scoring]: 'Scoring',
	[FootballPerformanceCategory.GameOutcome]: 'Game Outcome',
	[FootballPerformanceCategory.QuarterbackPlay]: 'Quarterback Play',
	[FootballPerformanceCategory.RushingReceiving]: 'Rushing & Receiving',
};
